import { render } from "./ShippingReceive.vue?vue&type=template&id=d6ccd91c&scoped=true"
import script from "./ShippingReceive.vue?vue&type=script&lang=js"
export * from "./ShippingReceive.vue?vue&type=script&lang=js"

import "./ShippingReceive.vue?vue&type=style&index=0&id=d6ccd91c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6ccd91c"]])

export default __exports__